import { isUndefined } from 'lodash/fp';
import { put, all, call, fork, select, takeLeading } from 'redux-saga/effects';

import { PdfPageText, PdfSearchResults } from '../../document-viewer/store/types';
import { setSearchResults } from '../../document-viewer/store/actions';
import { getPdfText } from '../../document-viewer/store/selectors';
import { askChatbotFailed, askChatbotStarted, askChatbotSuccessful, setAISortedResults } from './actions';
import { ChatbotActionTypes } from './types';
import { askAIQuestion } from '../../../../services/ai';
import { MLPageData } from '../../../datasets/store/mlTypes';
import { getSelectedDocumentId } from '../../my-documents/store/selectors';
import { getHighlightIndexesForPageText } from '../../document-viewer/store/utils';

export function* attemptAskChatbot({ payload }: ReturnType<typeof askChatbotStarted>) {
    const errorMessage = 'Sorry, I cannot answer that question right now, please try a different question or ask again.';
    try {
        const documentId: number | null = yield select(getSelectedDocumentId);
        if (!documentId) {
            throw 'Cannot find document ID';
        }
        const pdfPageText: PdfPageText[] = yield select(getPdfText);
        const { value, page, snippet }: MLPageData = yield call(askAIQuestion, { documentId, question: payload });
        let indexes: number[] = [];
        let isFuzzyMatch = false;
        if (!isUndefined(page)) {
            const pageText = pdfPageText.find(({ pageNumber }) => pageNumber === page);
            if (!isUndefined(pageText)) {
                const { uniqueIndexes, isFuzzyMatchHighlight } = getHighlightIndexesForPageText(snippet!, pageText);
                indexes = uniqueIndexes;
                isFuzzyMatch = isFuzzyMatchHighlight;
                const results: PdfSearchResults = { page, indexes: uniqueIndexes };
                yield put(setAISortedResults(results));
                yield put(setSearchResults([results]));
            }
        }
        if (isUndefined(page) && value === '') {
            yield put(askChatbotFailed(errorMessage));
            return;
        }
        yield put(askChatbotSuccessful(value, page, snippet, indexes, isFuzzyMatch));
    } catch (e) {
        yield put(askChatbotFailed(errorMessage));
    }
}

function* attemptAskChatbotWatcher() {
    yield takeLeading(ChatbotActionTypes.ASK_CHATBOT_STARTED, attemptAskChatbot);
}

export function* chatbotSaga() {
    yield all([
        fork(attemptAskChatbotWatcher)
    ]);
}
